export default "__VITE_ASSET__BDT_zb3x__"